import ReactDOM from 'react-dom/client';
import axios, { AxiosResponse } from "axios";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { API_HOST, QUERY_DEVTOOLS } from "@/core/variables";
import queryClient from "@/core/queryClient";
import { isSessionExpiredError } from "@/core/error";
import * as serviceWorker from "@/core/serviceWorker";
import { ApiResponse } from "@/model";
import App from '@/App';
import "@/assets/styles/index.scss";
import 'rc-slider/assets/index.css';


axios.defaults.withCredentials = true;
axios.interceptors.response.use(
    response => {
        return response as AxiosResponse<ApiResponse<unknown>>;
    },
    error => {
        // Redirect to login page if login session is expired
        // but session expiration error should not be caught by ErrorBoundary
        if (isSessionExpiredError(error)) {
            window.location.replace(`${API_HOST}/v1/auth/login?client_redirect_uri=${document.URL}`);
            return new Promise(() => {});
        } else {
            return Promise.reject(error);
        }
    }
);

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

root.render(
    <QueryClientProvider client={queryClient}>
        <App/>
        {QUERY_DEVTOOLS && (
            <ReactQueryDevtools initialIsOpen={false} position="right" />
        )}
    </QueryClientProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
